import React, { useState, createContext, useContext } from 'react';
export type Lang = 'UA' | 'RU' | 'EN';
interface LanguageContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
}
const LanguageContext = createContext<LanguageContextValue>({
  lang: 'UA',
  setLang: () => {}
});
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('UA');
  return <LanguageContext.Provider value={{
    lang,
    setLang
  }} data-id="element-538">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}